import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { AppContext } from '../../Store';
import { OneLPSsdkParamsContext } from '../../onelps-sdk-params-context';
import PreLanderStep from './PreLanderStep';
import styles from '../../css/components/pre-lander/preLander.css';

const PreLander = () => {
	const [state, dispatch] = useContext(AppContext);
	const onelpsParams = useContext(OneLPSsdkParamsContext);
	const { t, i18n } = useTranslation('translation');
	const { gameId, preLander, bigbeat: extraClassName } = onelpsParams;

	const getTranslation = (key) => {
		const gameKey = `${key}.${gameId}`;
		return i18n.exists(gameKey) ? t(gameKey) : t(`${key}.generic`);
	};

	const handleAnswer = (stepNumber) => {
		if (stepNumber < 3) {
			dispatch({ type: 'SET_PRE_LANDER_STEP', payload: stepNumber + 1 });
		} else {
			dispatch({ type: 'COMPLETE_PRE_LANDER' });
		}
	};

	if (state.preLanderCompleted || !preLander?.show) {
		return null;
	}

	const currentStep = state.preLanderStep || 1;
	const isFinalStep = currentStep === 3;

	return (
		<div
			className={styles.preLanderOverlay}
			data-testid="pre-lander"
		>
			<div className={styles.preLanderContent}>
				<PreLanderStep
					stepNumber={currentStep}
					extraClassName={extraClassName}
					question={getTranslation(`preLander.step${currentStep}.question`)}
					answer1={getTranslation(`preLander.step${currentStep}.answer1`)}
					answer2={!isFinalStep ? getTranslation(`preLander.step${currentStep}.answer2`) : null}
					answer1Subtext={isFinalStep ? getTranslation(`preLander.step${currentStep}.answer1Subtext`) : null}
					onAnswer={() => handleAnswer(currentStep)}
					gameId={gameId}
					isFinalStep={isFinalStep}
				/>
			</div>
		</div>
	);
};

export default PreLander;
